module.exports = __webpack_public_path__ + "865f339e78a1af6d8d6bf7a5a3ec91bf.png";